<script setup lang="ts">
    import type { AiMessage } from '~/stores/aiAssistantTypes';
    import { AI_INTERACTION_TYPE } from '~/stores/aiAssistantTypes';

    defineProps<{
        message: AiMessage;
    }>();

    const emit = defineEmits<{
        (e: 'option-selected', value: string, metadata?: Record<string, any>): void;
        (e: 'open-inline-form', value: string): void;
    }>();

    const formattedTime = (d: Date) =>
        `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
</script>

<template>
    <div class="flex flex-col gap-[5px] items-start py-[8px] w-full">
        <div class="w-full bg-white border border-[#E7E7E7] rounded-[12px] rounded-bl-[4px] px-4 py-3 shadow-[0_1px_2px_rgba(0,0,0,0.03)] flex flex-col gap-[10px]">
            <p class="font-inter text-[13px] leading-[1.5] text-gray-900 font-medium">
                {{ message.content }}
            </p>
            <AiMessageAiInteractiveYesNo
                v-if="message.interactionType === AI_INTERACTION_TYPE.YES_NO"
                :message="message"
                @option-selected="(value) => emit('option-selected', value)"
            />
            <AiMessageAiInteractiveRadio
                v-else
                :message="message"
                @option-selected="(value, metadata) => emit('option-selected', value, metadata)"
                @open-inline-form="(value) => emit('open-inline-form', value)"
            />
        </div>
        <span class="font-poppins text-[10px] text-[#abb5c0]">{{ formattedTime(message.timestamp) }}</span>
    </div>
</template>
